import React from 'react';
import './MilitaryBanner.css';

const MilitaryBanner = () => {
  return (
    <div className="military-banner">
      <div className="banner-section army">
        <h3>EJÉRCITO</h3>
      </div>
      <div className="banner-section air-force">
        <h3>FUERZA AÉREA</h3>
      </div>
      <div className="banner-section national-guard">
        <h3>GUARDIA NACIONAL</h3>
      </div>
    </div>
  );
};

export default MilitaryBanner;
